import { render } from "./MainPageLayout.vue?vue&type=template&id=fc6e09be&scoped=true"
import script from "./MainPageLayout.vue?vue&type=script&lang=js"
export * from "./MainPageLayout.vue?vue&type=script&lang=js"

import "./MainPageLayout.vue?vue&type=style&index=0&id=fc6e09be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6e09be"]])

export default __exports__